import { doubleToStringMonthly, standardNumberFormat } from "../../../objects/CommonUse/double_functions";
import changeFirstCharToUpperCase from "../../../objects/CommonUse/change_first_char_to_upper_case";

export const determineAchievementTextLine = (checkAmount, criteria, additionalText, earnedAchievement,  
        featureDisplayName, featureUnlocked, unlockedFeature, featureActive, criteriaAmount) => {
    let insertValue = "";
    let amountType = criteria.amountType;
    if (criteria.amountType === "percent" && criteria.pctBase){
        amountType = "amount";
    }
    if (checkAmount !== "N/A"){
        switch (amountType){
            case "number":
                 insertValue = standardNumberFormat(checkAmount);
                 break;
            case "amount":
                if (+checkAmount === 0){
                    insertValue = "$0";
                }else{
                    insertValue = doubleToStringMonthly(checkAmount);
                }
                break;
            case "percent":
                insertValue = standardNumberFormat(checkAmount) + "%";
                break;
            default:
                break;
        }
    }

    let displayName = criteria.displayName;
    if (criteria.displayNA && checkAmount === "N/A"){
        displayName = criteria.displayNA;
    }
    if (criteria.amountType === "percent" && criteria.pctBase){
        if (checkAmount === "N/A"){
            additionalText = "Your " + displayName + " cannot be determined."; 
        }else{
            const upperCaseDisplayName = changeFirstCharToUpperCase(displayName);
            additionalText = upperCaseDisplayName + " must be " + criteria.operation + " " +
                doubleToStringMonthly(criteriaAmount) +   
                " and your " + displayName + " are " + insertValue + ".";
        }
    }else{
        if (checkAmount === "N/A"){
            additionalText = "No " + displayName + " found.";
        }else{
            if (additionalText === ""){
                additionalText = "Your current " + displayName + " is " + insertValue + ".";
            }
        }
    }
    if (unlockedFeature === true && (+checkAmount === 0 || checkAmount === "N/A")){
          if (featureUnlocked){
            if (featureActive === false){
                additionalText += " The " + featureDisplayName + " has been unlocked but you have not " +
                    "activated the feature."
            }else{
                //  no additional text required
            }
          }else{
              additionalText += " The " + featureDisplayName + " has not been unlocked. ";
          }
    }
    
    let textColor = "black";
    if (earnedAchievement === true){
        textColor = "green";
    }
    const textObj = {textLine: additionalText, textColor: textColor};
    return textObj;
}
export default determineAchievementTextLine;